import { render } from "./InfoPopup.vue?vue&type=template&id=9aa2fab0&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"

import "./InfoPopup.vue?vue&type=style&index=0&id=9aa2fab0&scoped=true&lang=scss"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa2fab0"]])

export default __exports__